import styled from "styled-components";
import { deviceDF } from "utils/breakPoints";
import { BLUE_RGB } from "utils/colorsTheme";

// Styled Components

const TitleWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;
const TitleStyled = styled.h4`
  color: #3c4858;
`;

 const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  flex-wrap: wrap;
  @media ${deviceDF.tablet} {
    flex-direction: column;
  }
`;
// Styles Mui
const styles = (theme) => {
  return ({
  cardBody: {
    position: "relative",
  },
  buttonIcon: {
    margin: "0 !Important",
  },
  thTable: {
    fontSize: "1rem",
    fontWeight: "bold",
    color: BLUE_RGB,
    textAlign: 'start'
  },
})};

export { styles, TitleStyled, TitleWrapperStyled, ColumnContainer };
